__turbopack_context__.v({
  "addressLink": "StoreInformationModal-module-scss-module__HmfUkW__addressLink",
  "altRow": "StoreInformationModal-module-scss-module__HmfUkW__altRow",
  "colourHeader": "StoreInformationModal-module-scss-module__HmfUkW__colourHeader",
  "colourHeaderFirst": "StoreInformationModal-module-scss-module__HmfUkW__colourHeaderFirst",
  "colourImage": "StoreInformationModal-module-scss-module__HmfUkW__colourImage",
  "colourLabel": "StoreInformationModal-module-scss-module__HmfUkW__colourLabel",
  "desktopCloseButton": "StoreInformationModal-module-scss-module__HmfUkW__desktopCloseButton",
  "desktopCloseButtonIcon": "StoreInformationModal-module-scss-module__HmfUkW__desktopCloseButtonIcon",
  "divider": "StoreInformationModal-module-scss-module__HmfUkW__divider",
  "grid": "StoreInformationModal-module-scss-module__HmfUkW__grid",
  "gridScroller": "StoreInformationModal-module-scss-module__HmfUkW__gridScroller",
  "headerContent": "StoreInformationModal-module-scss-module__HmfUkW__headerContent",
  "headerRow": "StoreInformationModal-module-scss-module__HmfUkW__headerRow",
  "heading": "StoreInformationModal-module-scss-module__HmfUkW__heading",
  "headingRow": "StoreInformationModal-module-scss-module__HmfUkW__headingRow",
  "intrinsicColumn": "StoreInformationModal-module-scss-module__HmfUkW__intrinsicColumn",
  "mobileCloseButton": "StoreInformationModal-module-scss-module__HmfUkW__mobileCloseButton",
  "modalContainer": "StoreInformationModal-module-scss-module__HmfUkW__modalContainer",
  "modalScrollable": "StoreInformationModal-module-scss-module__HmfUkW__modalScrollable",
  "openHours": "StoreInformationModal-module-scss-module__HmfUkW__openHours",
  "root": "StoreInformationModal-module-scss-module__HmfUkW__root",
  "sizeCell": "StoreInformationModal-module-scss-module__HmfUkW__sizeCell",
  "sizeHeader": "StoreInformationModal-module-scss-module__HmfUkW__sizeHeader",
  "srOnly": "StoreInformationModal-module-scss-module__HmfUkW__srOnly",
  "stockCell": "StoreInformationModal-module-scss-module__HmfUkW__stockCell",
  "stockCellContent": "StoreInformationModal-module-scss-module__HmfUkW__stockCellContent",
  "stockIcon": "StoreInformationModal-module-scss-module__HmfUkW__stockIcon",
  "storeOption": "StoreInformationModal-module-scss-module__HmfUkW__storeOption",
  "storeOptionList": "StoreInformationModal-module-scss-module__HmfUkW__storeOptionList",
  "storeOptionSelected": "StoreInformationModal-module-scss-module__HmfUkW__storeOptionSelected",
  "storeSelectorContainer": "StoreInformationModal-module-scss-module__HmfUkW__storeSelectorContainer",
  "storeSelectorLabel": "StoreInformationModal-module-scss-module__HmfUkW__storeSelectorLabel",
  "storeSelectorWrap": "StoreInformationModal-module-scss-module__HmfUkW__storeSelectorWrap",
});
